import { useLongPress } from 'use-long-press';
import AirPlane from '../comps/AirPlane.jsx';
import Custom from '../comps/Custom/index.jsx';
import DayTitle from '../comps/DayTitle.jsx';
import Divider from '../comps/Section/Divider.jsx';
import Transfer from '../comps/Transfer/index.jsx';
import type { IListItem } from '../interface.js';
import { memo, type ReactNode } from 'react';
import isEqual from 'react-fast-compare';
import useCommonMenu, {
  type IUseCommonMenuProp,
} from '@/hooks/useCommonMenu.jsx';
import Add from '../comps/Add/index.jsx';
import Route from '../comps/Route/index.jsx';

type IContext = Omit<IUseCommonMenuProp, 'date' | 'id'>;
export type IRenderListContext = IContext;

const Wrapper = memo(
  ({
    children,
    context,

    id,
  }: {
    children: ReactNode;
    context: IContext;

    id: string;
  }) => {
    const { placeholder: menuCommonPlaceholder, show: showCommonMenu } =
      useCommonMenu({ ...context, id });

    const bind = useLongPress(() => {
      showCommonMenu();
    });

    return (
      <>
        <article {...bind()} className=' px-5 py-4'>
          {children}
        </article>
        {menuCommonPlaceholder}
      </>
    );
  },
  isEqual
);

export function renderList(item: IListItem, context: IContext) {
  const { type, props, key, orderIdx } = item;

  if (type === 'DayTitle') {
    return <DayTitle key={key} {...props} />;
  }
  if (type === 'div') {
    return <div key={key} {...props} />;
  }
  if (type === 'Transfer') {
    return <Transfer key={key} {...props} />;
  }
  if (type === 'Custom') {
    return (
      <Wrapper key={key} context={context} id={item.props.id}>
        {/* {orderIdx} */}
        <Custom key={key} {...props} />
      </Wrapper>
    );
  }
  if (type === 'Route') {
    return (
      <Wrapper key={key} context={context} id={item.props.id}>
        {/* {orderIdx} */}
        <Route key={key} {...props} />
      </Wrapper>
    );
  }
  if (type === 'Divider') {
    return <Divider key={key} {...props} />;
  }

  if (type === 'AirPlane') {
    return (
      <Wrapper key={key} context={context} id={item.props.id}>
        <AirPlane {...props} />
      </Wrapper>
    );
  }

  if (type === 'Add') {
    return <Add key={key} {...props} />;
  }

  return null;
}
